import api from "./client";

/* Billing API — bound to C's billing_app, every route verified live on
   os.abon.ai 2026-09-05 (status codes noted). Base: /api/billing/.
   Source of truth: billing_app/services/summary.py + the Connect onboarding
   contract (CONNECT_ONBOARDING_ENDPOINT_CONTRACT_2026-09-05.md). */

// GET 200 — rich per-tenant summary: connect + keys(+provenance) + surfaces + payments.
// Permission: admin / manager / owner (superuser passes). This is Screen 1's data.
export const getBillingSummary = (params = {}) =>
  api.get("/billing/summary/", { params });

// GET 200 — cross-tenant rollup, one row per active tenant. Superuser-only.
// This is Screen 2's data. { tenants: [...], count }.
export const getPlatformSummary = (params = {}) =>
  api.get("/billing/platform-summary/", { params });

// GET 200 — live Connect status (requirements_due, can_accept_payments,
// disabled_reason). Used to poll during onboarding; ?refresh=1 forces Stripe.
export const getConnectStatus = (params = {}) =>
  api.get("/billing/connect/status/", { params });

// POST 200 — mint a single-use, ~10-min, login-free hosted onboarding link.
// body: { confirm: true } (required — the backend refuses without it; it may create
// the tenant's connected account) + optional { email, business_url, return_url, refresh_url }.
export const createOnboardingLink = (body = {}) =>
  api.post("/billing/connect/onboarding-link/", body);

/* Regenerate = re-POST the SAME route. The deployed backend has NO separate
   /regenerate/ endpoint (verified 404); posting again reuses the account and
   mints a fresh single-use link, which is exactly the documented behavior. */
export const regenerateOnboardingLink = (body = {}) =>
  api.post("/billing/connect/onboarding-link/", body);
